import { isTouchDevice } from "common/utils/browser";
import "./quantity-price-popover.scss";

class QuantityPricePopover {
  #SELECTORS = {
    QTY_PRICING_POPOVER: ".js-qty-pricing-popover",
    QTY_PRICING_POPOVER_CONTENT: ".js-qty-pricing-popover-content"
  };

  #$productCard;

  #isOpen = false;

  get #$qtyPricingPopover() {
    return this.#$productCard.querySelector(this.#SELECTORS.QTY_PRICING_POPOVER);
  }

  get #$allPopoverContents() {
    return document.querySelectorAll(this.#SELECTORS.QTY_PRICING_POPOVER_CONTENT);
  }

  get #$openPopover() {
    return document.querySelector(`${this.#SELECTORS.QTY_PRICING_POPOVER_CONTENT}:not(.hidden)`);
  }

  get #$popoverContent() {
    return this.#$qtyPricingPopover.querySelector(this.#SELECTORS.QTY_PRICING_POPOVER_CONTENT);
  }

  #toggleQtyPricingPopover(isKeyboardEvent = false) {
    if (!this.#$qtyPricingPopover) return;

    // Need to perform actions on the same instance of the popover content.
    const $popoverContent = this.#$popoverContent;

    this.#$allPopoverContents.forEach($content => {
      if ($content !== this.#$popoverContent) {
        $content.classList.add("hidden");
      }
    });

    const wasOpen = !$popoverContent.classList.contains("hidden");
    $popoverContent.classList.toggle("hidden");
    this.#isOpen = !wasOpen;

    this.#$qtyPricingPopover.setAttribute("aria-expanded", this.#isOpen);

    if (this.#isOpen) {
      $popoverContent.setAttribute("tabindex", "-1");
      if (isKeyboardEvent) {
        $popoverContent.focus();
      }
    }
  }

  #handleTouchStart = e => {
    if (!this.#$openPopover) return;

    const $popoverContainer = this.#$openPopover.closest(this.#SELECTORS.QTY_PRICING_POPOVER);

    if (!$popoverContainer.contains(e.target)) {
      this.#toggleQtyPricingPopover();
    }
  };

  #handleKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.#toggleQtyPricingPopover(true);
    }
  };

  #handleDocumentKeyDown = e => {
    if (e.key === "Escape" && this.#isOpen) {
      this.#toggleQtyPricingPopover(true);
    }
  };

  #handleClickOutside = e => {
    if (!this.#isOpen) return;

    const $popoverContainer = this.#$qtyPricingPopover;
    if (!$popoverContainer.contains(e.target)) {
      this.#toggleQtyPricingPopover();
    }
  };

  init($productCard) {
    this.#$productCard = $productCard;

    if (!this.#$qtyPricingPopover) return;

    this.#$qtyPricingPopover.addEventListener("keydown", this.#handleKeyDown);

    if (isTouchDevice()) {
      this.#$qtyPricingPopover.addEventListener("click", () => {
        this.#toggleQtyPricingPopover();
      });
    } else {
      this.#$qtyPricingPopover.addEventListener("mouseenter", () => {
        this.#toggleQtyPricingPopover();
      });

      this.#$qtyPricingPopover.addEventListener("mouseleave", () => {
        this.#toggleQtyPricingPopover();
      });

      // Add click support for keyboard users on desktop
      this.#$qtyPricingPopover.addEventListener("click", () => {
        this.#toggleQtyPricingPopover();
      });
    }

    document.addEventListener("touchstart", this.#handleTouchStart);
    document.addEventListener("keydown", this.#handleDocumentKeyDown);
    document.addEventListener("click", this.#handleClickOutside);
  }
}

export default $productCard => new QuantityPricePopover().init($productCard);
